import types from './types';

const getCentersRequest = () => ({
  type: types.GET_CENTERS_REQUEST
});

const getCentersSuccess = (centers) => ({
  type: types.GET_CENTERS_SUCCESS,
  centers
});

const getCentersFailure = (error) => ({
  type: types.GET_CENTERS_FAILURE,
  error
});

const createCenterRequest = (center) => ({
  type: types.CREATE_CENTER_REQUEST,
  center
});

const createCenterSuccess = () => ({
  type: types.CREATE_CENTER_SUCCESS
});

const createCenterFailure = (error) => ({
  type: types.CREATE_CENTER_FAILURE,
  error
});

const updateCenterRequest = (id, center, version) => ({
  type: types.UPDATE_CENTER_REQUEST,
  id,
  center,
  version
});

const updateCenterSuccess = (id) => ({
  type: types.UPDATE_CENTER_SUCCESS,
  id
});

const updateCenterFailure = (id, error) => ({
  type: types.UPDATE_CENTER_FAILURE,
  id,
  error
});

const deleteCenterRequest = (id, version) => ({
  type: types.DELETE_CENTER_REQUEST,
  id,
  version
});

const deleteCenterSuccess = (id) => ({
  type: types.DELETE_CENTER_SUCCESS,
  id
});

const deleteCenterFailure = (id, error) => ({
  type: types.DELETE_CENTER_FAILURE,
  id,
  error
});

const subscribeCenters = () => ({
  type: types.SUBSCRIBE_CENTERS
});

const unsubscribeCenters = () => ({
  type: types.UNSUBSCRIBE_CENTERS
});

const subscriptionCenterCreated = (createdCenter) => ({
  type: types.SUBSCRIPTION_CENTER_CREATED,
  createdCenter
});

const subscriptionCenterUpdated = (updatedCenter) => ({
  type: types.SUBSCRIPTION_CENTER_UPDATED,
  updatedCenter
});

const subscriptionCenterDeleted = (deletedCenter) => ({
  type: types.SUBSCRIPTION_CENTER_DELETED,
  deletedCenter
});

export default {
  getCentersRequest,
  getCentersSuccess,
  getCentersFailure,
  createCenterRequest,
  createCenterSuccess,
  createCenterFailure,
  updateCenterRequest,
  updateCenterSuccess,
  updateCenterFailure,
  deleteCenterRequest,
  deleteCenterSuccess,
  deleteCenterFailure,
  subscribeCenters,
  unsubscribeCenters,
  subscriptionCenterCreated,
  subscriptionCenterUpdated,
  subscriptionCenterDeleted
};
